import axios from 'axios';

// const API_URL = 'http://localhost:8080'; 
// const API_URL = 'https://groupd-b.hkcl.net';
const API_URL = 'https://csharyanagroupdb.hkcl.net';

const apiService = axios.create({
  baseURL: API_URL,
  headers: {
        'Content-Type': 'application/json',
    }
});


export default apiService;
